import * as React from 'react';
import * as HmiFiles from '../../hmilib/hmifiles';
import '../../hmilib/hmiglobal';
import LoadPage from './../LoadPage';
import TopMenu from './TopMenu';
import Tree from './Tree';
import './webelement.css';

import { ISystemLib, TypeSystemEnum } from '../../hmilib/hmiglobal';

import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { render } from 'react-dom';
import { useStores } from 'store';
import ContextMenuWeb from './ContextMenuWeb';

interface imain {}

const Main = (props: imain) => {
    const { SystemStore } = useStores();
    const [loadstate, setLoadState] = React.useState(false);
    const [openWindowTree, setOpenWindowTree] = React.useState(true);

    const [NumInst, setNumInst] = React.useState<string>('');
    const [NameState, setNameState] = React.useState<string>('');
    const [TrenName, setTrenName] = React.useState<string>('');

    const [VisibleTopMenu, setVisibleTopMenu] = React.useState<boolean>(true);

    let ContextMenuDiv = function (
        event: any,
        item: string,
        trendparam: string,
        typemenu: number,
        x: number,
        y: number
    ) {
        console.log('ContextMenuDiv');
        let contextmenu = document.getElementById('menucontext');
        if (contextmenu == null) {
            contextmenu = document.createElement('div');
            contextmenu.id = 'menucontext';
            document.getElementsByTagName('body')[0].appendChild(contextmenu);
        } else {
            contextmenu.innerHTML = '';
        }

        contextmenu.style.position = 'absolute';
        contextmenu.style.background = '#fff';
        contextmenu.style.width = '150px';
        contextmenu.style.zIndex = '9999';
        contextmenu.style.top = y.toString() + 'px';
        contextmenu.style.left = x.toString() + 'px';

        render(<ContextMenuWeb anchorEl={contextmenu} itemname={item} trendparam={trendparam} />, contextmenu);
    };

    const defSystemLibWebElem: ISystemLib = {
        funglobal: {
            ContextMenuDiv: ContextMenuDiv
        }
    };

    React.useEffect(() => {
        let pagename = 'iXyber Vision Web';

        window.TypeSystem = TypeSystemEnum.WebElement;

        window.setSystemLib(defSystemLibWebElem);

        //document.title = pagename + ": " + NumInst + ". " + TrenName + " (" + NameState + ")";

        document.title = pagename;

        return function clear() {
            HmiFiles.CloseAll();
        };
    }, [NumInst, NameState, TrenName]);

    useEffect(() => {
        if (SystemStore.loadState) {
            setLoadState(true);
        }
    }, [SystemStore.loadState]);

    if (!loadstate) {
        return <LoadPage visible={true} />;
    } else if (VisibleTopMenu) {
        return (
            <div className="webelement">
                <ContextMenuWeb itemname="1" trendparam="1" />
                <div
                    className="no-print"
                    style={{
                        display: 'flex',
                        height: openWindowTree ? '100%' : '2.7em',
                        width: openWindowTree ? '25%' : '3.2em',
                        boxShadow: openWindowTree ? '4px 4px 4px rgba(0, 0, 0, 0.05)' : '',
                        overflow: openWindowTree ? 'auto' : 'hidden',
                        maxWidth: openWindowTree ? '25%' : '3.2em',
                        transition: 'margin-left .3s, opacity .3s, max-width .3s, height .3s, width .3s',
                        float: 'left',
                        background: '#1d212b',
                        color: '#8b98b1',
                        overflowX: 'hidden'
                    }}>
                    <div
                        style={{
                            background: '#fff',
                            height: '100%',
                            width: '100%',
                            overflow: openWindowTree ? 'auto' : 'hidden',
                            transition: 'opacity .3s'
                        }}>
                        <div
                            style={{
                                cursor: 'pointer',
                                display: openWindowTree ? 'flex' : 'none',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '2.8em',
                                background: '#1d212b',
                                transition: 'opacity 1s'
                            }}
                            onClick={() => {
                                setOpenWindowTree(false);
                            }}>
                            {'<<'}
                        </div>
                        <div
                            style={{
                                float: 'left',
                                width: '100%',
                                height: 'calc(100% - 2.8em)',
                                background: '#1d212b',
                                color: '#8b98b1',
                                overflow: 'auto',
                                overflowX: 'hidden'
                            }}>
                            <Tree />
                        </div>
                    </div>
                    <div
                        style={{
                            cursor: 'pointer',
                            boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.05)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            background: '#fff',
                            color: '#8b98b1',
                            height: '3.4em',
                            width: '17.2em',
                            overflow: !openWindowTree ? 'auto' : 'hidden',
                            maxWidth: !openWindowTree ? '3.2em' : '0em',
                            transition: 'opacity 1s, max-width .3s'
                        }}
                        onClick={() => {
                            setOpenWindowTree(true);
                        }}>
                        {'>>'}
                    </div>
                </div>

                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        paddingLeft: openWindowTree ? '25%' : '0%',
                        transition: 'padding-left .3s'
                    }}>
                    <div style={{ height: '48px' }}>
                        <TopMenu />
                    </div>
                    <div id="main" className="webelement-main" style={{ width: '100%', height: 'calc(100% - 48px)' }}>
                        <iframe id="mainframe" name="mainframe" className="webelement-main__frame"></iframe>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="webelement">
                <div id="main" className="webelement-main">
                    <iframe id="mainframe" className="webelement-main__frame"></iframe>
                </div>
            </div>
        );
    }
};

export default observer(Main);
